import {useParams, navigate, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {saveTimeLog, getTimeLog} from "../services/api";

export function EditTimeLog() {
    const { timeLogId } = useParams()
    const [timeLog, setTimeLog] = useState({})
    const navigate = useNavigate()
    
    useEffect(() => {
        if (timeLogId !== "new") {
            getTimeLog(timeLogId)
                .then(tl => {
                    setTimeLog(tl);
                })
                .catch(ex => {
                    console.log("Error saving time log: ", ex)
                })
        } else {
            let today = new Date()
            let todayFormat = `${today.getFullYear()}-${today.getMonth()}-${today.getDay()}`
            setTimeLog({
                ...timeLog,
                workDate: todayFormat
            })
        }
    }, []);
    
    const updateProject = (event) => {
        setTimeLog({
            ...timeLog,
            project: event.target.value
        })
    }
    
    const updateWorkDate = (event) => {
        setTimeLog({
            ...timeLog,
            workDate: event.target.value
        })
    }
    
    const updateStart = (event) => {
        setTimeLog({
            ...timeLog,
            startTime: event.target.value
        })
    }
    
    const updateEnd = (event) => {
        setTimeLog({
            ...timeLog,
            endTime: event.target.value
        })
    }
    
    const updateNotes = (event) => {
        setTimeLog({
            ...timeLog,
            notes: event.target.value
        })
    }
    
    const submit = async (event) => {
        event.preventDefault();
        try {
            await saveTimeLog(timeLog)
            navigate("/timelogs")
        } catch(ex) {
            console.log("Error saving time log: ", ex)
        }
    }
    
    return (
        <form onSubmit={submit}>
            <div className="form-group mb-3">
                <label>Project</label>
                <input className="form-control" type="text" value={timeLog.project} onChange={updateProject}/>
            </div>

            <div className="form-group mb-3">
                <label>Work Date</label>
                <input className="form-control" type="text" value={timeLog.workDate} onChange={updateWorkDate} />
            </div>
            <div className="form-group mb-3">
                <label>Start</label>
                <input className="form-control" type="text" value={timeLog.startTime} onChange={updateStart}/>
            </div>

            <div className="form-group mb-3">
                <label>End</label>
                <input className="form-control" type="text" value={timeLog.endTime} onChange={updateEnd}/>
            </div>

            <div className="form-group mb-3">
                <label>Notes</label>
                <textarea className="form-control" type="text" value={timeLog.Notes} onChange={updateNotes}></textarea>
            </div>
            <div className="form-group">
                <button className="btn btn-primary">Submit</button>
            </div>
        </form>
    )
}